module.exports = __webpack_public_path__ + "static/media/logo-onoiwa-plus-ori.249ae099.png";